import React, { lazy, Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import CircularProgress from "../Components/CircularProgress";
import { loaderStyle } from "../Styles/CircularProgress";
import "../Styles/GlobalStyles/GlobalStyles.css";
import AboutPage from "../Pages/LandingPage/AboutPage/AboutPage";
import About2 from "../Pages/LandingPage/AboutPage/About2";
import About3 from "../Pages/LandingPage/AboutPage/About3";
import ContactUsPage from "../Pages/LandingPage/ContactPage/ContactPage";
import Wrapper from "../Pages/LandingPage/HomePage/Wrapper";
import Dashboard from "../Pages/HQAdminPortal/Routes/Dashboard/DashboardPage/Dashboard";
import HomeLayout from "../Pages/HQAdminPortal/Routes/Dashboard/Home";
import SkillAcquisitionCentre from "../Pages/HQAdminPortal/Routes/Dashboard/SkillAcquisitionCentre";
import PartnerManagement from "../Pages/HQAdminPortal/Routes/Dashboard/PartnerManagement";

import MangeSuccessfulBusiness from "../Pages/HQAdminPortal/Routes/Dashboard/MangeSuccessfulBusiness/MangeSuccessfulBusiness";

import LoanSetup from "../Pages/HQAdminPortal/Routes/Dashboard/LoanManagement/LoanSetup";

import LoanStatus from "../Pages/HQAdminPortal/Routes/Dashboard/LoanManagement/LoanStatus";

import NotFound from "../Pages/NotFoundPage/NotFound";
import SkillSetUp from "../Pages/HQAdminPortal/Routes/Dashboard/SkilSetManagement/SkillSetUp";
import NotFoundDashboard from "../Pages/NotFoundPage/NotFoundDashboard";
import PhysicalApproval from "../Pages/HQAdminPortal/TrainersManagement/PhysicalApproval";
import { Provider } from "react-redux";
import store from "../Store";
import ReduxToastr from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import RequireAuth from "../Hooks/RequireAuth";
import RedirectUser from "../Hooks/Redirect";
import ChangePassword from "../Pages/ChangePassword";


// Training Center Imports
import TrainersManagement from "../Pages/HQAdminPortal/TrainersManagement";
import VirtualApproval from "../Pages/HQAdminPortal/TrainersManagement/VirtualApproval";
import TrainingCentreRegistration from "../Pages/LandingPage/TrainingCentreRegistration";
import ViewTrainer from "../Pages/HQAdminPortal/TrainersManagement/ViewTrainer";
import PhysicalApprovalForm from "../Components/PhysicalApprovalForm";

// Post Camp Activities
import ManagePostCampActivities from "../Pages/HQAdminPortal/Routes/Dashboard/PostCampActivities";
import ManageInCampActivities from "../Pages/HQAdminPortal/Routes/Dashboard/InCampActivities";

import ManageSuccessStories from "../Pages/HQAdminPortal/Routes/Dashboard/SuccessStories/ManageSuccessStories";
import UpdateTrainingCentreReg from "../Pages/LandingPage/TrainingCentreRegistration/UpdateTrainingCentreReg";

// Monitoring and Evaluation
import MonitoringAndEvaluation from "../Pages/HQAdminPortal/Routes/Dashboard/MonitoringAndEvaluation";
import PostCampMonitoring from "../Pages/HQAdminPortal/Routes/Dashboard/MonitoringAndEvaluation/PostCampMonitoring"
import GrantBenForm from "../Pages/HQAdminPortal/Routes/Dashboard/MonitoringAndEvaluation/GrantBenForm";
import OrientationForm from "../Pages/HQAdminPortal/Routes/Dashboard/MonitoringAndEvaluation/OrientationForm";
import UserManagement from "../Pages/HQAdminPortal/Routes/Dashboard/UserManagement/UserManagement";

// Corp Member SAED pages
const InCampTrainingForm = lazy(() => import("../Pages/HQAdminPortal/Routes/Dashboard/CmMgt/InCampTrainingForm"))

const LandingPage = lazy(() => import("../Pages/LandingPage/HomePage/HomePage"));

// User Authentication
const Login = lazy(() => import("../Pages/Login/Login"));
const VerifyLink = lazy(() => import("../Pages/Login/VerifyLink"));



function AppRoutes() {
  return (
    <Provider store={store}>
      <Router>
        <RedirectUser />
        <Suspense
          fallback={
            <div className="loader-view" style={loaderStyle}>
              <CircularProgress />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Wrapper />}>
              <Route index element={<LandingPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="about2" element={<About2 />} />
              <Route path="about3" element={<About3 />} />
              <Route path="contactUs" element={<ContactUsPage />} />
              <Route path="trainingCentreRegistration" element={<TrainingCentreRegistration />} />
              <Route path="trainingCentreRegistrationUpdate" element={<UpdateTrainingCentreReg />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/verifyLink" element={<VerifyLink />} />

            <Route element={<RequireAuth />}>
              <Route path="/changePassword" element={<ChangePassword />} />
              <Route path="home" element={<HomeLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="skillsetmanagement/setup" element={<SkillSetUp />} />
                <Route
                  path="partnermanagement"
                  element={<PartnerManagement />}
                />
                <Route path="loanmanagement">
                  <Route path="loansetup" element={<LoanSetup />} />
                  <Route path="loanstatus" element={<LoanStatus />} />
                </Route>

                <Route path="trainersmanagement" >
                  <Route path="trainersListing" element={<TrainersManagement />} />
                  <Route path="virtualApproval">
                    <Route index element={<VirtualApproval />} />
                    <Route path="approveTrainer" element={<ViewTrainer />} />
                  </Route>
                  <Route path="physicalApproval" element={<PhysicalApproval />} />
                  <Route path="physicalApprovalReport" element={<PhysicalApprovalForm />} />
                </Route>
                <Route
                  path="skillacquisitioncentre"
                  element={<SkillAcquisitionCentre />}
                />
                <Route path="monitoringandevaluation" >
                  <Route path="dashboard" element={<MonitoringAndEvaluation />} />
                  <Route path="postCampMonitoring" element={<PostCampMonitoring />} />
                  <Route path="grantBenForm" element={<GrantBenForm />} />
                  <Route path="orientationForm" element={<OrientationForm />} />

                </Route>
                <Route
                  path="managesuccessfulbusiness"
                  element={<MangeSuccessfulBusiness />}
                />
                <Route
                  path="managesuccessstories"
                  element={<ManageSuccessStories />}
                />


                <Route
                  path="usermanagement"
                  element={<UserManagement />}
                />
                <Route path="cmMgtModule">
                  <Route path="inCampTrainingForm" element={<InCampTrainingForm />} />

                  <Route
                    path="managePostCampActivities"
                    element={<ManagePostCampActivities />}
                  />
                  <Route
                    path="manageInCampActivities"
                    element={<ManageInCampActivities />}
                  />
                </Route>
                <Route path="*" element={<NotFoundDashboard />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
      <ReduxToastr
        timeOut={6000}
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        getState={(state) => state.toastr}
        transitionIn="bounceIn"
        transitionOut="bounceOut"
        progressBar
        closeOnToastrClick
      />
    </Provider>
  );
}

export default AppRoutes;
